import React from "react";
import styled, { css } from "styled-components";
import { ReactComponent as DropdownCaret } from "../../assets/img/downArrow.svg";

const Button = ({
    text,
    width,
    onButtonClick,
    disabled,
    isSubmitting,
    type,
    onSubmit,
    background,
    Icon,
    extraStyles,
    height,
    borderRadius,
    disabledStyle,
    className = "",
    iconChild,
    hasDropdown = false,
    textColor = "#ffffff",
}) => {
    return (
        <ButtonStyled
            width={width}
            onClick={onButtonClick}
            disabled={disabled || isSubmitting}
            type={type}
            onSubmit={onSubmit}
            background={background}
            extraStyles={extraStyles}
            height={height}
            borderRadius={borderRadius}
            disabledStyle={disabledStyle}
            textColor={textColor}
            className={className}
        >
            {Icon && (
                <div className="button-icon">
                    <Icon />
                </div>
            )}
            {iconChild && <div className="button-icon">{iconChild}</div>}
            {isSubmitting ? <span className="form-loading"></span> : text}
            {hasDropdown && (
                <div className="button-dropdown-arrow">
                    <DropdownCaret />
                </div>
            )}
        </ButtonStyled>
    );
};

export const LightButton = ({
    text,
    width,
    onButtonClick,
    disabled,
    isSubmitting,
    type,
    onSubmit,
    icon,
    height,
    borderRadius,
    className,
    extraStyles,
    iconChild,
    border = "1px solid #000000",
    background = "#f9f9f9",
}) => {
    return (
        <LightButtonStyled
            className={className}
            width={width}
            onClick={onButtonClick}
            disabled={disabled}
            type={type}
            onSubmit={onSubmit}
            height={height}
            borderRadius={borderRadius}
            extraStyles={extraStyles}
            border={border}
            background={background}
        >
            {isSubmitting ? (
                <span className="spinner"></span>
            ) : (
                <>
                    {icon ? <span>{icon}</span> : ""}
                    {iconChild && <div className="button-icon">{iconChild}</div>}
                    {text}
                </>
            )}
        </LightButtonStyled>
    );
};

const ButtonStyled = styled.button`
    width: ${({ width }) => (width ? width : "180px")};
    height: ${({ height }) => (height ? height : "48px")};
    background: ${({ background }) => (background ? background : "#000000")};
    border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : "10px")};
    font-weight: 700;
    font-size: 1rem;
    line-height: 25px;
    text-align: center;
    color: ${({ textColor }) => textColor};
    opacity: ${({ disabled, disabledStyle }) => (disabled ? "0.4" : disabledStyle ? "0.6" : "")};
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

    ${({ extraStyles }) =>
        extraStyles &&
        css`
            display: flex;
            align-items: center;
            justify-content: center;

            .button-icon {
                margin-right: 6px;
                margin-top: 6px;
            }
            .button-dropdown-arrow {
                margin-left: 16px;
                margin-bottom: 4px;
                svg {
                    path {
                        fill: #ffffff;
                    }
                }
            }
        `}
`;

const LightButtonStyled = styled(ButtonStyled)`
    background: ${({ background }) => background};
    border: ${({ border }) => border};
    color: #000000;
    span {
        margin-right: 12px;
    }
    .spinner {
        margin-left: 50%;
        margin-right: 0px;
    }
`;

export default Button;
